(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p4-how-we-help"] && !Shopify.designMode) return;
  try {
    
  class P4Carousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.dotsEl = this.querySelector('[data-dots]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (!this.track || !this.slides.length) return;
      this.buildDots();
      this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    }
    buildDots() {
      this.dotsEl.innerHTML = '';
      this.dots = this.slides.map((slide, i) => {
        const b = document.createElement('button');
        b.className = 'p4-carousel__dot';
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', () => {
          this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'instant' });
        });
        this.dotsEl.appendChild(b);
        return b;
      });
    }
    onScroll() {
      if (this._raf) return;
      this._raf = requestAnimationFrame(() => {
        this._raf = null;
        const center = this.track.scrollLeft + this.track.clientWidth / 2;
        let active = 0, min = Infinity;
        this.slides.forEach((s, i) => {
          const sc = s.offsetLeft - this.track.offsetLeft + s.clientWidth / 2;
          const d = Math.abs(sc - center);
          if (d < min) { min = d; active = i; }
        });
        this.dots.forEach((d, i) => d.setAttribute('aria-current', i === active ? 'true' : 'false'));
      });
    }
  }
  if (!customElements.get('p4-carousel')) customElements.define('p4-carousel', P4Carousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p4-sticky-cart"] && !Shopify.designMode) return;
  try {
    
  class P4StickyCart extends HTMLElement {
    connectedCallback() {
      this.removeAttribute('hidden');
      this._onScroll = () => this.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.6);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      this._onScroll();
    }
    disconnectedCallback() { window.removeEventListener('scroll', this._onScroll); }
  }
  if (!customElements.get('p4-sticky-cart')) customElements.define('p4-sticky-cart', P4StickyCart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p4-therapy-browser"] && !Shopify.designMode) return;
  try {
    
  class P4Tabs extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('.p4-tabs__nav');
      this.pill = this.querySelector('[data-pill]');
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      if (!this.tabs.length) return;
      this.activeTab = this.tabs.find((t) => t.classList.contains('is-active')) || this.tabs[0];

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab.dataset.tab));
        tab.addEventListener('mouseenter', () => this.highlight(tab, true));
        tab.addEventListener('focus', () => this.highlight(tab, true));
      });
      if (this.nav) this.nav.addEventListener('mouseleave', () => this.highlight(this.activeTab, true));

      this.select = this.querySelector('[data-tabselect]');
      if (this.select) this.select.addEventListener('change', () => this.activate(this.select.value));

      requestAnimationFrame(() => this.highlight(this.activeTab, false));
      this._onResize = () => this.movePill(this._current || this.activeTab, false);
      window.addEventListener('resize', this._onResize);
    }
    disconnectedCallback() { if (this._onResize) window.removeEventListener('resize', this._onResize); }
    highlight(tab, animate) {
      if (!tab) return;
      this.tabs.forEach((t) => t.classList.toggle('is-highlight', t === tab));
      this.movePill(tab, animate);
    }
    movePill(tab, animate) {
      if (!this.pill || !tab) return;
      if (!animate) this.pill.style.transition = 'none';
      this.pill.style.width = tab.offsetWidth + 'px';
      this.pill.style.height = tab.offsetHeight + 'px';
      this.pill.style.transform = 'translate(' + tab.offsetLeft + 'px, ' + tab.offsetTop + 'px)';
      if (!animate) { void this.pill.offsetWidth; this.pill.style.transition = ''; }
      this._current = tab;
    }
    activate(id) {
      this.tabs.forEach((t) => {
        const on = t.dataset.tab === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) this.activeTab = t;
      });
      this.panels.forEach((p) => {
        const on = p.dataset.panel === id;
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
      if (this.select && this.select.value !== id) this.select.value = id;
      this.highlight(this.activeTab, true);
    }
  }
  if (!customElements.get('p4-tabs')) customElements.define('p4-tabs', P4Tabs);

  } catch(e) { console.error(e); }
})();
})();
